import { DetailForm } from "./detail";

const createFormModal = {
  type: 'modal',
  width: 1000,
  title: '{{CREATE}} {{REWARD_PROGRAM}}',
  openActionKey: 'isCreate',
  closeActionKey: 'CLOSE_DETAIL_MODAL',
  children: [
    DetailForm
  ]
};

const updateFormModal = {
  type: 'modal',
  width: 1000,
  title: '{{UPDATE}} {{REWARD_PROGRAM}}',
  openActionKey: 'isUpdate',
  closeActionKey: 'CLOSE_DETAIL_MODAL',
  children: [
    DetailForm
  ]
};

const deleteConfirmationModal = {
  type: 'modal',
  width: 520,
  title: '{{ARE_YOU_SURE}}',
  openActionKey: 'programToDelete',
  closeActionKey: 'CLOSE_DELETE_CONFIRMATION',
  children: [
    {
      type: 'text',
      className: 'd-block',
      content: '{{ARE_YOU_SURE_YOU_WANT_TO_DELETE_REWARD_PROGRAM}}'
    },
    {
      type: 'text',
      className: 'd-block font-weight-bold mt-2',
      dataKey: 'programToDelete.name'
    },
    {
      type: 'div',
      className: 'd-flex justify-content-end w-100',
      children: [
        {
          type: 'button',
          buttonType: 'text',
          className: 'custom-color my-3',
          style: { backgroundColor: '$quaternary', color: '#ffffff' },
          actionKey: 'CONFIRM_DELETE',
          children: [
            {
              type: 'text',
              content: '{{YES}}'
            }
          ]
        },
        {
          type: 'button',
          buttonType: 'text',
          className: 'custom-color my-3 ml-1',
          style: { backgroundColor: '$quaternary', color: '#ffffff' },
          actionKey: 'CLOSE_DELETE_CONFIRMATION',
          children: [
            {
              type: 'text',
              content: '{{NO}}'
            }
          ]
        }
      ]
    }
  ]
};

export {
  createFormModal,
  updateFormModal,
  deleteConfirmationModal
};
